function getServerURL() {
  const localhost = "http://localhost:3123";
  const staging = "https://interlink-api.cloudxier.dev";
  const production = "https://api.itpl.com.au";

  let host = window.location.host;
  if (host) {
    host = host.toLowerCase();
  }

  let env;
  switch (host) {
    case "http://localhost:3000":
      env = localhost;
      break;
    case "interlink-assessment-form.netlify.app":
      env = staging;
      break;
    case "assessment.itpl.com.au":
      env = production;
      break;
    default:
      env = localhost;
  }
  return env;
}

export default getServerURL;
